<!--
  Proposta C: cabeçalho de uma linha (só identidade, X nativo), corpo de altura fixa em duas
  colunas — contexto à esquerda (sempre as mesmas linhas), textos à direita (rolam) — e a
  navegação ‹ n de N › no rodapé. O [formGroup] fica no p-dialog porque o <ng-template #header>
  é declarado aqui dentro e o campo de instalação vive no cabeçalho durante a edição.
  closable=false: o close() do PrimeNG (X, ESC, máscara) esconde o dialog antes de avisar, sem
  hook cancelável, então a guarda de edição suja não conseguia segurá-lo aberto. Os três
  caminhos são nossos: X no header, ESC e clique na máscara (HostListeners no componente),
  todos passando pelo requestClose, que decide entre fechar e pedir confirmação.
-->
<p-dialog [formGroup]="form" [visible]="visible" (visibleChange)="onVisibleChange($event)" [modal]="true"
  [draggable]="false" [resizable]="false" [closable]="false"
  [style]="{ width: '1040px', maxWidth: '96vw' }" position="top" styleClass="os-dialog" maskStyleClass="os-dialog-mask">

  <ng-template #header>
    <div class="os-head">
      <span class="os-head-title">{{ 'service-order.service-order-title' | translate }}</span>
      <span class="os-head-sep">·</span>
      <span class="os-head-kv">
        <span class="os-head-k">{{ 'service-order.id-label' | translate }}</span>
        <span class="os-head-v">{{ serviceOrder.reference }}</span>
      </span>
      <span class="os-head-sep">·</span>
      <span class="os-head-kv">
        <span class="os-head-k" [title]="'service-order.installation-tooltip' | translate">{{ 'service-order.installation-label' | translate }}</span>

        @if (!isEditing) {
        <span class="os-head-v">
          <i class="pi pi-map-marker"></i>
          {{ serviceOrder.installation.reference || ('service-order.not-informed' | translate) }}
        </span>
        } @else if (!installationChangeOpen) {
        <!-- Trocar instalação se edita onde a instalação é lida; continua atrás de um clique
             porque regrava coordenadas e MAC -->
        <button type="button" class="os-head-v os-head-v--editable" (click)="openInstallationChange()"
          [pTooltip]="'service-order.button-change-installation' | translate" tooltipPosition="bottom"
          [attr.aria-label]="'service-order.button-change-installation' | translate">
          <i class="pi pi-map-marker"></i>
          {{ serviceOrder.installation.reference || ('service-order.not-informed' | translate) }}
          <i class="pi pi-pencil os-head-pen"></i>
        </button>
        } @else {
        <span class="os-installation-editor">
          <i class="pi pi-info-circle os-head-info" tabindex="0"
            [pTooltip]="'service-order.installation-search-hint' | translate" tooltipPosition="bottom"
            [attr.aria-label]="'service-order.installation-search-hint' | translate"></i>
          <p-autoComplete inputId="os-edit-installation" formControlName="selectedInstallation"
            [suggestions]="installationOptions" (completeMethod)="searchInstallation($event)"
            optionLabel="reference" [forceSelection]="true" [minLength]="3" [delay]="350" appendTo="body"
            [placeholder]="'service-order.installation-search-placeholder' | translate"
            [emptyMessage]="'service-order.no-results-found' | translate">
            <ng-template let-option #item>
              <span class="os-installation-option">
                <span class="os-installation-option-ref">{{ option.reference }}</span>
                @if (option.serialNumber) {
                <span class="os-installation-option-serial">{{ 'service-order.serial-label' | translate }} {{ option.serialNumber }}</span>
                }
              </span>
            </ng-template>
          </p-autoComplete>
          <button type="button" class="os-installation-cancel" (click)="cancelInstallationChange()"
            [pTooltip]="'service-order.button-cancel' | translate" tooltipPosition="bottom"
            [attr.aria-label]="'service-order.button-cancel' | translate">
            <i class="pi pi-times"></i>
          </button>
        </span>
        }
      </span>

      <span class="os-head-grow"></span>
      <button type="button" class="os-head-close" (click)="requestClose()"
        [attr.aria-label]="'service-order.close-dialog-label' | translate">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </ng-template>

  <div class="os-body">
    @if (installationChangeOpen) {
    <p-message severity="warn" size="small" styleClass="os-body-message">
      {{ 'service-order.change-installation-warning' | translate }}
    </p-message>
    }
    @if (savedMessageVisible) {
    <p-message severity="success" size="small" styleClass="os-body-message">
      {{ 'service-order.saved-message' | translate }}
    </p-message>
    }

    <div class="os-cols">
      <!-- ================================ coluna de contexto ================================ -->
      <aside class="os-side">
        @if (!isEditing) {
        <div class="os-kv">
          <span class="os-k">{{ 'service-order.status-label' | translate }}</span>
          <span class="os-v">
            <p-tag [severity]="statusMeta.severity" [icon]="statusMeta.icon"
              [value]="statusMeta.labelKey | translate" [styleClass]="statusMeta.styleClass" />
          </span>
        </div>
        <div class="os-kv">
          <span class="os-k">{{ 'service-order.priority-label' | translate }}</span>
          <span class="os-v">
            <span class="prio-pill" [ngClass]="priorityMeta.cssClass">
              <i [class]="priorityMeta.icon"></i>
              {{ priorityMeta.labelKey | translate }}
            </span>
          </span>
        </div>
        @for (row of facts; track row.key) {
        <div class="os-kv">
          <span class="os-k">{{ row.labelKey | translate }}</span>
          <span class="os-v" [class.os-v--empty]="!row.value">{{ row.value || '—' }}</span>
        </div>
        }
        } @else {
        <!-- Enum em <select> nativo: popup do SO, não disputa z-index nem rola o modal -->
        <div class="os-kv">
          <label class="os-k" for="os-edit-status">{{ 'service-order.status-label' | translate }} *</label>
          <select id="os-edit-status" class="os-select" formControlName="status">
            @for (option of statusOptions; track option.value) {
            <option [value]="option.value">{{ option.label }}</option>
            }
          </select>
        </div>
        <div class="os-kv">
          <label class="os-k" for="os-edit-priority">{{ 'service-order.priority-label' | translate }} *</label>
          <select id="os-edit-priority" class="os-select" formControlName="priority">
            @for (option of priorityOptions; track option.value) {
            <option [value]="option.value">{{ option.label }}</option>
            }
          </select>
        </div>
        <div class="os-kv">
          <label class="os-k" for="os-edit-assignee">{{ 'service-order.assigned-to' | translate }}</label>
          <p-autoComplete inputId="os-edit-assignee" class="w-full" formControlName="selectedUser"
            [suggestions]="userOptions" (completeMethod)="searchUser($event)" optionLabel="displayName"
            [forceSelection]="true" [delay]="350" appendTo="body"
            [emptyMessage]="'service-order.no-results-found' | translate">
            <ng-template let-user #item>
              <span class="os-user-option">
                <span class="os-user-option-name">{{ user.displayName }}</span>
                @if (user.username && user.username !== user.displayName) {
                <span class="os-user-option-login">{{ user.username }}</span>
                }
              </span>
            </ng-template>
          </p-autoComplete>
          @if (userFilterLoading) {
          <p-progressbar mode="indeterminate" [style]="{ height: '3px' }" />
          }
        </div>
        }

        <!-- Timeline vertical: estado vem do status, não do timestamp (alerts-api grava
             started_at/closed_at sem tocar a coluna status) -->
        <ol class="os-vtl" [attr.aria-label]="'service-order.timeline-title' | translate">
          @for (node of timeline; track node.labelKey) {
          <li class="os-vtl-node">
            <span class="os-vtl-dot" [ngClass]="'os-vtl-dot--' + node.state"></span>
            <span class="os-vtl-text">
              <span class="os-vtl-label">{{ node.labelKey | translate }}</span>
              <span class="os-vtl-date" [class.os-vtl-date--empty]="!node.date" [title]="node.date">
                {{ shortDate(node.date) || '—' }}
                @if (node.inconsistent) {
                <i class="pi pi-exclamation-triangle os-vtl-warning"
                  [pTooltip]="'service-order.timeline-inconsistent' | translate" tooltipPosition="top"
                  [attr.aria-label]="'service-order.timeline-inconsistent' | translate"></i>
                }
              </span>
            </span>
          </li>
          }
        </ol>
      </aside>

      <!-- ================================ coluna de texto ================================ -->
      <div class="os-main">
        @if (!isEditing) {
        @for (section of sections; track section.key) {
        <div class="os-sec" [ngClass]="'os-sec--' + section.key">
          <h3 class="os-sec-title">{{ section.labelKey | translate }}</h3>
          <p class="os-sec-text" [class.os-sec-text--empty]="!section.value">
            {{ section.value || ('— ' + (section.emptyKey | translate)) }}
          </p>
        </div>
        }
        } @else {
        <div class="os-field">
          <label class="os-label" for="os-edit-problems">{{ 'service-order.problems-label' | translate }}</label>
          <textarea pTextarea id="os-edit-problems" class="w-full" formControlName="problems"
            rows="6"></textarea>
        </div>
        <div class="os-field">
          <label class="os-label" for="os-edit-notes">{{ 'service-order.notes-label' | translate }}</label>
          <textarea pTextarea id="os-edit-notes" class="w-full" formControlName="notes" rows="3"></textarea>
        </div>
        <!-- Status Finalizada mostra os detalhes e o checkbox de pendência (mesmo padrão do dialog Finalizar OS) -->
        @if (requiresCloseNotes) {
        <div class="os-field os-finish-field" [class.os-finish-field--issues]="closeNotesRequired">
          <div class="os-finish-row">
            <label class="os-label" for="os-edit-close-notes">{{ 'service-order.close-notes-label' | translate }}</label>
            <span class="os-req-tag" [class.os-req-tag--required]="closeNotesRequired">
              {{ (closeNotesRequired ? 'service-order.tag-required' : 'service-order.tag-optional') | translate }}
            </span>
            <label class="os-issues-toggle" for="os-edit-with-issues">
              <input type="checkbox" id="os-edit-with-issues" formControlName="withIssues">
              {{ 'service-order.with-issues-label' | translate }}
              <i class="pi pi-info-circle os-issues-info" tabindex="0"
                [pTooltip]="'service-order.with-issues-tooltip' | translate" tooltipPosition="bottom"
                [attr.aria-label]="'service-order.with-issues-tooltip' | translate"></i>
            </label>
          </div>
          <textarea pTextarea id="os-edit-close-notes" class="w-full" formControlName="closeNotes" rows="3"
            [placeholder]="(closeNotesRequired ? 'service-order.close-notes-required-placeholder' : 'service-order.close-notes-placeholder') | translate"
            [class.p-invalid]="closeNotesError" [attr.aria-invalid]="closeNotesError"
            [attr.aria-describedby]="closeNotesError ? 'os-edit-close-notes-error' : null"></textarea>
          @if (closeNotesError) {
          <span id="os-edit-close-notes-error" class="os-field-error" role="alert">
            <i class="pi pi-exclamation-circle"></i>
            {{ 'service-order.close-notes-error' | translate }}
          </span>
          }
        </div>
        }
        }
      </div>

      <!-- ================================ coluna da instalação ================================ -->
      <!-- Painel absoluto dentro da coluna: seu conteúdo não entra na altura do card, que segue
           ditada pela coluna de contexto (sempre as mesmas linhas). Texto a mais rola no painel. -->
      <div class="os-inst-col">
        <app-service-order-installation-panel class="os-inst-fill" [installation]="panelInstallation"
          [loading]="installationDetailsLoading" [reference]="serviceOrder.installation.reference" />
      </div>
    </div>
  </div>

  <ng-template #footer>
    <div class="os-foot">
      <!-- Navegação como paginação, o mesmo padrão da tabela logo abaixo do modal -->
      @if (canNavigate && total > 1) {
      <div class="os-pager" role="group" [attr.aria-label]="'service-order.button-previous' | translate">
        <button type="button" class="os-pager-btn" (click)="goPrevious()" [disabled]="!hasPrevious"
          [attr.aria-label]="'service-order.button-previous' | translate">
          <i class="pi pi-chevron-left"></i>
        </button>
        <span class="os-pager-count">
          {{ 'service-order.position-of' | translate: { position: position, total: total } }}
        </span>
        <button type="button" class="os-pager-btn" (click)="goNext()" [disabled]="!hasNext"
          [attr.aria-label]="'service-order.button-next' | translate">
          <i class="pi pi-chevron-right"></i>
        </button>
      </div>
      }

      <span class="os-foot-grow"></span>

      @if (updateLoading) {
      <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s"
        [style]="{ width: '32px', height: '32px' }" />

      } @else if (discardConfirmOpen) {
      <!-- Confirmação sem overlay: é o que garante que o modal sempre consegue sair da edição -->
      <span class="os-discard-question">{{ 'service-order.discard-changes-title' | translate }}</span>
      <p-button [label]="'service-order.button-keep-editing' | translate" severity="secondary"
        [outlined]="true" (onClick)="dismissDiscard()" />
      <p-button [label]="'service-order.button-discard' | translate" severity="danger"
        (onClick)="confirmDiscard()" />

      } @else if (isEditing) {
      <p-button [label]="'service-order.button-cancel' | translate" severity="secondary"
        (onClick)="cancelEdit()" />
      <p-button [label]="'service-order.button-save' | translate" icon="pi pi-check"
        [disabled]="form.invalid || !form.dirty" (onClick)="updateServiceOrder()" />

      } @else if (isClosed) {
      <span class="os-foot-hint">{{ 'service-order.closed-no-actions' | translate }}</span>

      } @else {
      <p-button [label]="'service-order.button-edit' | translate" icon="pi pi-pen-to-square"
        severity="secondary" [outlined]="true" (onClick)="enterEditMode()" />
      @if (serviceOrder.status === 'OPEN') {
      <p-button [label]="'service-order.button-start' | translate" icon="pi pi-play"
        styleClass="btn-actions" (onClick)="requestStart()" />
      }
      @if (serviceOrder.status === 'IN_PROGRESS') {
      <p-button [label]="'service-order.button-close' | translate" icon="pi pi-flag-fill"
        styleClass="btn-actions" (onClick)="requestFinish()" />
      }
      }
    </div>
  </ng-template>
</p-dialog>
